import React from 'react';
import { connect } from 'react-redux';
import { selectedAddress, duplexAddress } from '../../../selectors/ServiceAddress';
import AddressToString from '../AddressToString';

class ApplicantsInfo extends React.Component {
    getApplicantsDetail = ext => {
        const p = this.props;
        const f = p.form;
        const applicants = window.osa.lookup.projectSpecifics.gasAppliances.items;

        let aplicantsItems = applicants.map((p, i) => {
            if (f[p.name + ext] && f[p.name + ext]!=0)
                return (<li key={i}>{f[p.name + ext]} {p.name}</li>);
            else
                return null;
        });
        aplicantsItems = (<div><ul>{aplicantsItems}</ul></div>);
        const address = ext ? p.duplexAddress : p.address;
        const addressStr = <AddressToString {...address} />;
        return (
            <div className="row">
                <div className="col-sm-12">
                    <div className="panel panel-default">
                        <div className="panel-heading">
                            {addressStr}
                        </div>
                        <div className="panel-body">
                            <b>Appliances included:</b>
                            {aplicantsItems}
                            <b>Total area (sq ft):</b>
                            <br />
                            {f['buildingFootage' + ext]}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
    render() {
        const p = this.props;
        return (
            <div>
                {this.getApplicantsDetail('')}
                {(p.form.buildingType == "2" && p.form.duplexMeterCount == "2") ? this.getApplicantsDetail('2') : null}
            </div>
        );
    }
}
const mapStateToProps = (state) => {
    return {
        form: state.form,
        address: selectedAddress(state),
        duplexAddress: duplexAddress(state),
    };
};
export default connect(mapStateToProps)(ApplicantsInfo);